import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveFacetsModule, FacetListModule, IconModule, ProductFacetNavigationComponent } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';
import { GenFacetListComponent } from './facet-list/facet-list.component';
import { GenActiveFacetsComponent } from './active-facets/active-facets.component';

@Component({
  selector: 'gen-product-facet-navigation',
  templateUrl: './product-facet-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FacetListModule,
    ActiveFacetsModule,
    IconModule,
    I18nModule,
    GenFacetListComponent,
    GenActiveFacetsComponent,
  ]
})
export class GenProductFacetNavigationComponent extends ProductFacetNavigationComponent {

}
